import React, { Component} from 'react';
 

import CharacterCard from '../Parts/vcCharacterCard';
import EnemyCard from '../Parts/vcEnemyCard';
import Musuck from '../../../../images/OldVoidCheese.wav'
class vcGame extends Component {
  
  constructor(props) {
    super(props);
    this.getCharTarget = this.getCharTarget.bind(this);    
    this.setCharTarget = this.setCharTarget.bind(this);    
    this.handleLoop = this.handleLoop.bind(this);
    this.setChar = this.setChar.bind(this);
    this.setEnemy = this.setEnemy.bind(this);
    this.selEnemy = this.setEnemy.bind(this);
    this.getSelChar = this.getSelChar.bind(this);
    this.getSelEnemy = this.getSelEnemy.bind(this);
    this.getSelEnemyObj = this.getSelEnemyObj.bind(this);

    let ct = [];
    ct.push({type:'CAP',Target:'None'});
    ct.push({type:'N3RD',Target:'None'});
    ct.push({type:'SNIPE',Target:'None'});
    ct.push({type:'DOC',Target:'None'});
    this.state = {
      usr: props.data.usr,      
      logo: props.data.logo,
      gamestate: props.data.gamestate,
      handleStateChange: props.data.handleStateChange,
      startcnt: 0,
      selChar: {name:'Placeholder Jenkins',type:'CAP' , enemy:'None'},
      selEnemy: {},      
      setEnemy: this.setEnemy,
      setChar: this.setChar,
      CHARTARGS: ct,
      NMES: [],  
      
    }


   
    
    this.looppointer = {};
        
  }
  
getCharTarget(inCharType){
 
  let out ={};

  if(!this.state.CHARTARGS){ return;}
  

  let wrk = this.state.CHARTARGS.map((X)=>(X));
  wrk.forEach((X)=>{
   
    if(X.type===inCharType){
      
      out =  X.Target ;
    }
    
  });
  return out;
}
setCharTarget(inTargetName, inCharType){
  

   if(!this.state.CHARTARGS){  return;}

      let wrk = this.state.CHARTARGS.map(function(X){return X});
      wrk = wrk.forEach((X)=>{
    
      if(X.type===this.state.selChar.type){
        X.Target = inTargetName;
       
        this.setState({CHARTARGS:wrk});
        console.log('CHARTARGS==============>',this.state.CHARTARGS);
        return X;
        
        
      }
      
  });
  
  
  //this.setState({CHARTARGS:wrk});
  
}

setEnemy(inEnemy){

  const {name}=inEnemy;

  
  let bFound = false;
  
  try{
  this.state.NMES.forEach(function(obj,idx){
    console.log(name,obj.name);
    if(obj===name||obj.name===name){
      
      bFound=true;
      console.log('OBJ OBJ', obj);
      this.setCharTarget(obj.name,obj.type);      
    }}.bind(this))}
    catch(e){
      
        bFound=true;
    };

  if(bFound===false){
    this.state.NMES.push(inEnemy)
    
  }else{console.log('ENEMY EXISTS', inEnemy)};
  
  //SET CHARGETARGS


  this.setState({selEnemy:inEnemy});
  
  this.setCharTarget(inEnemy.name,inEnemy.type);
}

getSelEName (){
  return this.state.selEName;
}
getSelEnemy(){

    return this.state.selEnemy.name};
getSelEnemyObj(){
  return this.state.selEnemy;
}      
getSelChar(){

  return this.state.selChar};  
componentDidMount(){
 
  // this.looppointer = setInterval(this.handleLoop,1);
}  
setChar(inChar){

  //'console.log('setChar', inChar);
  
  this.setState({selChar: inChar});
}

// selEnemy(inEnemy){
//   console.log('SEL ENEMY!!!!', inEnemy)
//   this.setState({selEnemy: inEnemy});
  
// }


handleLoop(){
  let cnt = this.state.startcnt;
  cnt ++
  if (cnt>10000){cnt=0}
  this.setState({startcnt: cnt})
  
}
// setNoCharTouch(cb){
// let ntc = this.state.notouchcallbacks.slice();
// ntc.push(cb);
// this.setState({notouchcallbacks:ntc});

// }


closeMe(){
  clearInterval(this.looppointer);
  this.state.handleStateChange('end');
}

handleClick(event){
  this.closeMe();  
}  
   
    render() {
     // const pgImg ={width:'80px', height:'120px'}
     // const highlight ={backgroundColor:'darkgreen'}
      return (
        
      <div >
        <div ></div>         
        <audio id="muback" autoPlay loop>
          <source src={Musuck}/>
        </audio>
        <div className="container-fluid ">
        <div className="row">
          <div className="col-12"  onClick={(e)=>this.handleClick(e)}>Game Control Bar</div>
        </div>
        <div className="row">
        
         <div className="col-6"> <CharacterCard  getCharTarget={this.getCharTarget} getSelEnemyObj={this.getSelEnemyObj} getSelChar={this.getSelChar} selChar={this.state.selChar} setChar={this.setChar} NMES={this.state.NMES} char="CAP"/></div>
         <div className="col-6"><EnemyCard getSelChar={this.getSelEnemy} selChar={this.state.selEnemy} setChar={this.setEnemy} char="CAP"/></div>
        </div>
        <div className="row">
          
         <div className="col-6"><CharacterCard  getCharTarget={this.getCharTarget} getSelEnemyObj={this.getSelEnemyObj} getSelChar={this.getSelChar} selChar={this.state.selChar} setChar={this.setChar} NMES={this.state.NMES} char="N3RD"/></div>
         <div className="col-6"><EnemyCard getSelChar={this.getSelEnemy} selChar={this.state.selEnemy} setChar={this.setEnemy} char="N3RD"/></div>
        </div>
        <div className="row">
         <div className="col-6"><CharacterCard getCharTarget={this.getCharTarget}  getSelEnemyObj={this.getSelEnemyObj} getSelChar={this.getSelChar} selChar={this.state.selChar} setChar={this.setChar} NMES={this.state.NMES}  char="SNIPE"/></div>
         <div className="col-6"><EnemyCard getSelChar={this.getSelEnemy} selChar={this.state.selEnemy} setChar={this.setEnemy} char="SNIPE"/></div>
        </div>
        <div className="row">
         <div className="col-6"><CharacterCard getCharTarget={this.getCharTarget}  getSelEnemyObj={this.getSelEnemyObj} getSelChar={this.getSelChar} selChar={this.state.selChar} setChar={this.setChar} NMES={this.state.NMES}  char="DOC"/></div>
         <div className="col-6"><EnemyCard getSelChar={this.getSelEnemy} selChar={this.state.selEnemy} setChar={this.setEnemy} char="DOC"/></div>
        </div>
        </div>    
      </div>
              
           );            
              
  
      
    }  

  
  }
export default vcGame; 


// WEBPACK FOOTER //
// ./src/components/Games/VoidCheddar/Pages/game.js